import "../App.css";

function Challenge66() {
    return (
        <div className="App">
            <header className="App-header">
                <h3 style={{ marginTop: 0 }}>Leaderboard</h3>
                <p>
                    This is the leaderboard for Challenge 66. The top 10 participants are listed below.
                </p>
                <div style={{ display: "flex", justifyContent: "center", gap: "2rem", marginTop: "2rem" }}>
                    <div>
                        <h4>Male</h4>
                        <table style={{ borderCollapse: "collapse", minWidth: "200px" }}>
                            <thead>
                                <tr>
                                    <th style={{ border: "1px solid #ccc", padding: "6px" }}>Rank</th>
                                    <th style={{ border: "1px solid #ccc", padding: "6px" }}>Name</th>
                                    <th style={{ border: "1px solid #ccc", padding: "6px" }}>Power (W)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {[...Array(10)].map((_, i) => (
                                    <tr key={i}>
                                        <td style={{ border: "1px solid #ccc", padding: "6px" }}>{i + 1}</td>
                                        <td style={{ border: "1px solid #ccc", padding: "6px" }}>-</td>
                                        <td style={{ border: "1px solid #ccc", padding: "6px" }}>-</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <h4>Female</h4>
                        <table style={{ borderCollapse: "collapse", minWidth: "200px" }}>
                            <thead>
                                <tr>
                                    <th style={{ border: "1px solid #ccc", padding: "6px" }}>Rank</th>
                                    <th style={{ border: "1px solid #ccc", padding: "6px" }}>Name</th>
                                    <th style={{ border: "1px solid #ccc", padding: "6px" }}>Power (W)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {[...Array(10)].map((_, i) => (
                                    <tr key={i}>
                                        <td style={{ border: "1px solid #ccc", padding: "6px" }}>{i + 1}</td>
                                        <td style={{ border: "1px solid #ccc", padding: "6px" }}>-</td>
                                        <td style={{ border: "1px solid #ccc", padding: "6px" }}>-</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </header>
        </div>
    );
}

export default Challenge66;
// This code defines a React component for Challenge 66, which includes a header and a paragraph.